
import React, { useMemo, useState } from 'react';
import { Select } from 'v3/components';
import { useFleetManagement } from '../shared';

const SelectCellEditor = ((props) => {
  const { value, selectType, columnName } = props;
  const { filtersOptions } = useFleetManagement();
  const isMultiple = selectType?.includes('multi');

  const initialValues = useMemo(() => {

    if (columnName === 'config_automatic_availability') {
      if (value === true) return { value: true, label: 'Sim' };
      if (value === false) return { value: false, label: 'Não' };
      return null;
    }

    if (value && columnName === 'status_operational') {
      return Object.keys(value).length ? value : null;
    }

    return null;
  }, [value, columnName]);

  const [selectedValue, setSelectedValue] = useState(initialValues);

  const initialOptions = useMemo(() => {
    if (columnName === 'config_automatic_availability') {
      return [
        { value: true, label: 'Sim' },
        { value: false, label: 'Não' },
      ];
    }
    if (columnName === 'status_operational') return filtersOptions?.statusOperator || [];

    return [];
  }, [filtersOptions?.statusOperator, columnName]);

  const handleChange = (val) => {
    setSelectedValue(val);

    const newValue =
      columnName === 'config_automatic_availability'
        ? val?.value
        : val;

    props.onValueChange(newValue);
    props.stopEditing();
  };

  return (
    <div style={{
      width: '100%',
      minWidth: 200,
    }}>
      <Select
        options={initialOptions}
        onChange={handleChange}
        value={selectedValue}
        multiple={isMultiple}
        getOptionValue={(opt) => (columnName === 'status_operational' ? opt.id : opt?.value)}
        getOptionLabel={(opt) => (columnName === 'status_operational' ? opt.name : opt?.label)}
        useMenuPortal={true}
      />
    </div>
  );
});

export default SelectCellEditor;
